<template>
  <filtro-adicional-base
    :target="target"
    @aplicar-busca="aplicar()"
    @limpar="limpar()"
  >
    <template #conteudo-filtro-adicional>
      <b-row>
        <b-col cols="12">
          <tipo-tributacao-select
            v-model="value.tributacoes"
            :multiple="true"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <tipo-atividade-select
            v-model="value.atividades"
            :multiple="true"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-group label="ID Omie">
            <v-select
              v-model="value.buscaVinculoOmie"
              :options="[{value: 1, label: 'Sem Id Omie'}, {value: 2, label: 'ID Omie do Simples Nacional'}, {value: 3, label: 'ID Omie de outras tributações'}]"
              multiple
              :reduce="omie => omie.value"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-checkbox
            v-model="value.matriz"
            switch
          >
            Matriz
          </b-form-checkbox>
        </b-col>
      </b-row>
    </template>
  </filtro-adicional-base>
</template>

<script>
import '@core/scss/vue/libs/vue-select.scss'
import vSelect from 'vue-select'

export default {
  name: 'FiltroAdicional',
  components: {
    FiltroAdicionalBase: () => import('@/shared/components/filtro-adicional-base/FiltroAdicionalBase.vue'),
    TipoTributacaoSelect: () => import('@/shared/components/tipo-tributacao-select/TipoTributacaoSelect.vue'),
    TipoAtividadeSelect: () => import('@/shared/components/tipo-atividade-select/TipoAtividadeSelect.vue'),
    vSelect,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    target: {
      type: String,
      default: 'popover-filtro-servico',
    },
  },
  data() {
    return {
      popoverShow: false,
    }
  },
  methods: {
    onClose() {
      this.popoverShow = false
    },
    limpar() {
      this.value = {
        tributacao: null,
        atividade: null,
        buscaVinculoOmie: [],
        matriz: null,
      }
    },
    aplicar() {
      this.$emit('aplicar', this.value)
    },
  },
}
</script>
